import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import '../App.css'
import PlainHeader from '../components/PlainHeader'
import Footer from '../components/Footer'

class About extends Component {
  render() {
    return (
      <div className="main">
        <PlainHeader />
        <div className="container about">
          <h1>About SearchGull</h1>
          <p>
            SearchGull is a prop search engine. You can use it anywhere you need to show specific, tailored, or fictional search results.
            For instance, if you're making a mystery movie and need to show your amateur sleuth searching the internet 
            for information on a series of murders in a fictional town, SearchGull is for you.
          </p>
          <h2>How it works</h2>
          <p>
            SearchGull doesn't actually search the internet the way a real search engine does and won't return any results by default. 
            Instead, you <Link className="link-standard" to="/settings">enter your own search term(s)</Link> and the search results that go with each search term.
            Once you've set up all of the search terms and results you need, just go to the SearchGull <Link className="link-standard" to="/">home</Link> page, 
            type in your search term, and voila! Instant prop search results.
          </p>
          <h2>Why Use SearchGull?</h2>
          <p>Two main reasons:</p>
          <ul>
            <li>
              Tailored/fictional search results.
            </li>
            <li>
              Avoid trademark infringement issues that might arise when using a real search engine.
            </li>
          </ul>
          <h2>Features</h2>
          <ul>
            <li>
              Works offline (in modern browsers).
            </li>
            <li>
              No login required.
            </li>
            <li>
              Prop (fictional) search terms and results tailored to your project.
            </li>
            <li>
              Save and share your data with others.
            </li>
            <li>
              Free to use.
            </li>
            <li>
              No attribution required, but it'd be cool if you did. :)
            </li>
          </ul>
          <h2>License to Use</h2>
          <p>
            SearchGull and the SearchGull logo are &copy; and &trade; Matt Jordan. 
            I have no idea if anybody would actually use this app in a project like a movie, but here are the terms just in case. 
            Don't worry - they're pretty generous. 
          </p>
          <p>
            You are free to use the SearchGull web app, as is, in your creative work as a stand-in for a real search engine, i.e., as a prop search engine. 
            The app is free to use and display, including the display of the SearchGull logo as it exists within the app itself, without having to pay or get prior permission. 
            For instance you may: 
          </p>
          <ul>
            <li>
              Display the app and its use, including the SearchGull logo, in your film, televsion, videogame, or other creative visual works, in the context of
              searching for and returning prop search results.
            </li>
            <li>
              Depict (via drawings, screen captures, computer rendering, etc.) the use of the app in your comics, webcomics, and animated films.
            </li>
            <li>
              Use the SearchGull name in dialogue (written or recorded audio) as a stand-in for a real search engine. (For instance, "Let me SearchGull that for you.")
            </li>
          </ul>
          <p>
            Basically, if you're using it as a fictional/prop search engine, you're good.  Other uses outside the scope of a prop search engine, for instance the printing of T-shirts 
            with the SearchGull logo (not that there's a line of folks wanting to do that), are not allowed without prior permission.
          </p>
          <h2>App Limitations and Caveats</h2>
          <ul>
            <li>
              The app tries to use your browser's local storage (via IndexedDB) to save results for you, but that only saves them on the current device and in the current browser.
              You can, however, download a text file with your searches and then upload that file later, even on a different device.
              You do that from the <Link className="link-standard" to="/settings">settings</Link> page.
              In this way, you could create some prop search results on your desktop at home, then send them to be used on a laptop on location.
            </li>
            <li>
              SearchGull doesn't support image searches right now, but if people actually start using the app and there's a need for images, I'll add that in.
              In fact, the app is fairly minimal at the moment, but if the need arises for more functionality, I'll see what I can do.
            </li>
            <li>
              SearchGull also doesn't have multi-page results right now, but, again, if people want it I'll add it in.
            </li>
          </ul>
          <h2>About Matt Jordan</h2>
          <p>
            I'm a software engineer by day and a writer by night. 
            I've started a series of horror books for kids called <a className="link-standard" href="http://creepspace.com">Creepspace</a>, which I write under the pen name of E. C. Crawlie.
            The first book is called <a className="link-standard" href="https://thewitchgame.com">The Witch Game</a>. I hope to finally have a second book in 2018. 
            I was also one half of <a className="link-standard" href="http://baileyjester.com">Bailey Jester</a>, a folk duo that ran around singing stuff in the early 2000s.
          </p>
        </div>
        <Footer />
      </div>
    );
  }
}

export default About;


// WEBPACK FOOTER //
// ./src/pages/About.js